module.exports = __webpack_public_path__ + "static/media/sws-excel.09752ad1.svg";